import { useCreateTerminKalenderForm } from '@/domain/termine/features/CreateTerminKalender/shared/hooks/useCreateTerminKalenderForm';
import { CreateTerminKalenderFormContent } from '@/domain/termine/features/CreateTerminKalender/shared/CreateTerminKalenderFormContent';
import { CreateTerminKalenderDrawerHeader } from '@/domain/termine/features/CreateTerminKalender/Drawer/CreateTerminKalenderDrawerHeader';
import { CreateTerminKalenderFormContext } from '@/domain/termine/features/CreateTerminKalender/shared/CreateTerminKalenderFormContext';

type CreateTerminKalenderDrawerFormProps = {
  form: ReturnType<typeof useCreateTerminKalenderForm>;
  onSubmitSuccess: () => void;
};

export function CreateTerminKalenderDrawerForm({
  form,
  onSubmitSuccess,
}: CreateTerminKalenderDrawerFormProps) {
  return (
    <CreateTerminKalenderFormContext.Provider value={form}>
      <form.AppForm>
        <form
          className="flex h-full flex-col"
          onSubmit={async (e) => {
            e.preventDefault();
            await form.handleSubmit();
            if (form.state.isSubmitSuccessful) onSubmitSuccess();
          }}>
          <CreateTerminKalenderDrawerHeader />
          <div className="flex-1 overflow-y-auto overscroll-contain p-4">
            <CreateTerminKalenderFormContent />
          </div>
        </form>
      </form.AppForm>
    </CreateTerminKalenderFormContext.Provider>
  );
}
